import { Circle, Divider, Flex, Stack, StackProps, Text } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { Fragment } from 'react';

import { Airport, FlightSegment, useFlightSegmentsHelper } from '../../hooks/useFlightSegmentsHelper';

type Props = StackProps & {
  flightSegments: FlightSegment[];
};

export const AirportStops = ({ flightSegments = [], ...rest }: Props) => {
  const { airports } = useFlightSegmentsHelper(flightSegments);

  const renderFlightSegment = (airport: Airport, index: number) => {
    const isFirst = index === 0;
    const isLast = index === airports?.length - 1;
    const isSecondToLast = index === airports?.length - 2;

    return (
      <Fragment key={index}>
        <Flex>
          <Text textStyle="bodySmallRegular" color="text.subtle" fontWeight={isFirst || isLast ? 'bold' : 'normal'}>
            {airport?.id}
          </Text>
        </Flex>
        <Show if={!isLast}>
          <Stack direction="row" align="center" spacing="-1" flex={1}>
            <Show if={isFirst || isLast}>
              <Circle size="8px" bg="transparent" border="2px" borderColor="border.default" mr="-0.5" zIndex={2} />
            </Show>
            <Divider borderColor="border.default" opacity="1" borderWidth="1px" />
            <Show if={isSecondToLast}>
              <Circle size="8px" bg="transparent" border="2px" ml="-0.5" borderColor="border.default" fontSize="sm" />
            </Show>
          </Stack>
        </Show>
      </Fragment>
    );
  };

  return (
    <Stack direction="row" align="center" spacing={1} w="full" {...rest}>
      {airports?.map(renderFlightSegment)}
    </Stack>
  );
};
